"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyInsurerMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const policy_entity_1 = require("./policy.entity");
const address_entity_1 = require("./address.entity");
const contact_entity_1 = require("./contact.entity");
const insurer_entity_1 = require("./insurer.entity");
const look_up_entity_1 = require("./look-up.entity");
let PolicyInsurerMap = class PolicyInsurerMap {
};
exports.PolicyInsurerMap = PolicyInsurerMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], PolicyInsurerMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyInsurerMap.prototype, "policyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "insurer_participation_type_lid",
        type: "int",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", Number)
], PolicyInsurerMap.prototype, "insurerParticipationTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyInsurerMap.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_branch_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyInsurerMap.prototype, "insurerBranchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_contact_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyInsurerMap.prototype, "insurerContactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => policy_entity_1.Policy, (policy) => policy.insurerMappings, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "policy_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _a : Object)
], PolicyInsurerMap.prototype, "policy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => insurer_entity_1.Insurer, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "insurer_id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _b : Object)
], PolicyInsurerMap.prototype, "insurer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => address_entity_1.Address, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "insurer_branch_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _c : Object)
], PolicyInsurerMap.prototype, "insurerBranch", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "insurer_contact_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _d : Object)
], PolicyInsurerMap.prototype, "insurerContact", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({
        name: "insurer_participation_type_lid",
        referencedColumnName: "id",
    }),
    tslib_1.__metadata("design:type", typeof (_e = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _e : Object)
], PolicyInsurerMap.prototype, "insurerParticipationType", void 0);
exports.PolicyInsurerMap = PolicyInsurerMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("policy_insurer_map")
], PolicyInsurerMap);
